<div class="page-wide" ngClass.xs="mobile">
  <h2>MEMBER <span class="font-300">REWARDS</span></h2>

  <div class="greentree-split mt-section row">
    <div class="email-login col">
      <div class="login-container">
        <h3>Sign in to your account</h3>
        <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">

        <div class="clr-col">
          <label for="name" class="form-label">Email</label>
          <input formControlName="email" type="email" id="email" class="form-control" />
        </div>

        <br>

        <div class="clr-col">
          <label for="name" class="form-label">Password</label>
          <input formControlName="password" type="password" id="password" class="form-control" />
        </div>

        <div class="extra-links"><a routerLink="/forgot-password" class="black-text">Forgot Password?</a>  |  <a routerLink="/forgot-password" class="black-text">First Time Login</a></div>

        <div class="d-grid gap-2">
          <button class="btn btn-primary" type="submit" [disabled]="loginBtnLoading || !loginForm.valid">SIGN IN</button>
        </div>


      </form>
      </div>
    </div>

    <div class="register col">
      <h3>Become a rewards member</h3>
      <ul>
        <li>Special Rewards Member Rates</li>
        <li>Complimentary Upgrades*</li>
        <li>Early Check In / Late Check Out*</li>
      </ul>
      <a routerLink="/register">
        <button class="btn btn-outline register-btn">REGISTER</button></a>
    </div>
  </div>

</div>